import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;

export const createDebitsApi = async (data) => {
    try {
        const response = await axios.post(`${baseURL}/wallet/createDebits`, data, {
            headers: {
                "x-access-token": localStorage.getItem("CC_ADMIN_TOKEN"),
                "email": localStorage.getItem("CC_ADMIN_EMAIL"),
                "usertype": localStorage.getItem("CC_ADMIN_USERTYPE")
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401 || error.response.status === 403) {
            localStorage.clear();
            window.location.href = "/login";
        } else {
            console.error("Error:", error);
        }
        throw error;
    }
}

export const createCreditsApi = async (data) => {
    try {
        const response = await axios.post(`${baseURL}/wallet/createCredits`, data, {
            headers: {
                "x-access-token": localStorage.getItem("CC_ADMIN_TOKEN"),
                "email": localStorage.getItem("CC_ADMIN_EMAIL"),
                "usertype": localStorage.getItem("CC_ADMIN_USERTYPE")
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401 || error.response.status === 403) {
            localStorage.clear();
            window.location.href = "/login";
        } else {
            console.error("Error:", error);
        }
        throw error;
    }
}

export const getWalletDetailsApi = async (params) => {
    try {
        const response = await axios.get(`${baseURL}/wallet/getWalletDetails`, {
            params: {
                transactionType: params?.id,
                searchQuery: params?.searchQuery,
                debitType: params?.debitType,
                endFrom: params?.endFrom,
                fromDate: params?.fromDate,
                toDate: params?.toDate
            },
            headers: {
                "x-access-token": localStorage.getItem("CC_ADMIN_TOKEN"),
                "email": localStorage.getItem("CC_ADMIN_EMAIL"),
                "usertype": localStorage.getItem("CC_ADMIN_USERTYPE")
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401 || error.response.status === 403) {
            localStorage.clear();
            window.location.href = "/login";
        } else {
            console.error("Error:", error);
        }
        throw error;
    }
}

export const getWalletDriverDetails = async (id) => {
    try {
        const response = await axios.get(`${baseURL}/wallet/getWalletDriverDetails?driverId=${id}`, {
            headers: {
                "x-access-token": localStorage.getItem("CC_ADMIN_TOKEN"),
                "email": localStorage.getItem("CC_ADMIN_EMAIL"),
                "usertype": localStorage.getItem("CC_ADMIN_USERTYPE")
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401 || error.response.status === 403) {
            localStorage.clear();
            window.location.href = "/login";
        } else {
            console.error("Error:", error);
        }
        throw error;
    }
}

export const getWalletCount = async () => {
    try {
        const response = await axios.get(`${baseURL}/wallet/getWalletDetailsCount`, {
            headers: {
                "x-access-token": localStorage.getItem("CC_ADMIN_TOKEN"),
                "email": localStorage.getItem("CC_ADMIN_EMAIL"),
                "usertype": localStorage.getItem("CC_ADMIN_USERTYPE")
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401 || error.response.status === 403) {
            localStorage.clear();
            window.location.href = "/login";
        } else {
            console.error("Error:", error);
        }
        throw error;
    }
}

export const getSummary = async (from, to) => {
    try {
        const response = await axios.get(`${baseURL}/wallet/getSummary?fromDate=${from}&toDate=${to}`, {
            headers: {
                "x-access-token": localStorage.getItem("CC_ADMIN_TOKEN"),
                "email": localStorage.getItem("CC_ADMIN_EMAIL"),
                "usertype": localStorage.getItem("CC_ADMIN_USERTYPE")
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401 || error.response.status === 403) {
            localStorage.clear();
            window.location.href = "/login";
        } else {
            console.error("Error:", error);
        }
        throw error;
    }
}

export const getWalletDeductionAmountByTripId = async (id) => {
    try {
        const response = await axios.get(`${baseURL}/ride/getWalletDeductionAmountByTripId?id=${id}`, {
            headers: {
                "x-access-token": localStorage.getItem("CC_ADMIN_TOKEN"),
                "email": localStorage.getItem("CC_ADMIN_EMAIL"),
                "usertype": localStorage.getItem("CC_ADMIN_USERTYPE")
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401 || error.response.status === 403) {
            localStorage.clear();
            window.location.href = "/login";
        } else {
            console.error("Error:", error);
        }
        throw error;
    }
}